import { render } from "./ContactBadge.vue?vue&type=template&id=6d616d66&ts=true"
import script from "./ContactBadge.vue?vue&type=script&lang=ts"
export * from "./ContactBadge.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__